import React from "react";
import HeaderLogo from "src/assets/grit-leadership-logo.png";
const Headerpage: React.FC = () => {

    return (<>

         <div className="header">
                      <div className="cont-header" style={{
                        width: "100%",
                        height: "80px",
                        backgroundColor: "rgba(245, 245, 245, 1)",
                        cursor:"pointer"
                      }}>
                        <img src={HeaderLogo} onClick={() => {
                            window.location.href = "/"
                        //   this.props.history.push("/")
                        }} />
                      </div>
                    </div>
                    
        
        </>);
};

export default Headerpage;



// WEBPACK FOOTER //
// ./src/components/header.tsx